import { Button, Drawer, Form, Input, Radio } from 'antd';
import { useState } from 'react';
import type { RejectReasonType } from '../types/api';

/**
 * 六档驳回理由，与后端 REJECT_REASON_CODES 一一对应。
 * 顺序按使用频率排：时段冲突最常见，其他兜底放最后。
 */
const OPTIONS: { value: RejectReasonType; label: string }[] = [
  { value: 'time_conflict', label: '时段冲突' },
  { value: 'safety', label: '安全风险' },
  { value: 'materials', label: '材料试剂不足' },
  { value: 'equipment', label: '仪器设备不可用' },
  { value: 'procedure', label: '实验方案不完整' },
  { value: 'other', label: '其他' },
];

export function RejectDrawer(props: {
  open: boolean;
  onClose: () => void;
  onSubmit: (payload: { reason_code: RejectReasonType; reason_detail: string }) => Promise<void>;
}) {
  const [reason_code, setReason] = useState<RejectReasonType>('time_conflict');
  const [detail, setDetail] = useState('');
  const [loading, setLoading] = useState(false);
  // 选「其他」时必须写清楚，否则学生只看到"其他"两个字，等于没告诉原因
  const disabled = reason_code === 'other' && !detail.trim();

  return (
    <Drawer title="驳回原因" open={props.open} onClose={props.onClose} width={380}>
      <Form layout="vertical">
        <Form.Item label="原因类型" required>
          <Radio.Group
            value={reason_code}
            onChange={(e) => setReason(e.target.value)}
            className="stack"
          >
            {OPTIONS.map((o) => (
              <Radio key={o.value} value={o.value}>
                {o.label}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="补充说明"
          required={reason_code === 'other'}
          extra={reason_code === 'other' ? '选「其他」时必填' : '选填，200 字以内'}
        >
          <Input.TextArea
            rows={4}
            value={detail}
            onChange={(e) => setDetail(e.target.value)}
            maxLength={200}
            showCount
          />
        </Form.Item>
        <Button
          type="primary"
          danger
          className="touch"
          disabled={disabled}
          loading={loading}
          onClick={async () => {
            setLoading(true);
            try {
              await props.onSubmit({ reason_code, reason_detail: detail.trim() });
              setDetail('');
            } finally {
              setLoading(false);
            }
          }}
        >
          确认驳回
        </Button>
      </Form>
    </Drawer>
  );
}
